module.exports = __webpack_public_path__ + "static/media/КБП-Dark.c47b10cd.webp";